import { render } from "./monospace_block.vue?vue&type=template&id=b335516c&ts=true"
import script from "./monospace_block.vue?vue&type=script&lang=ts"
export * from "./monospace_block.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__